
import isFunction from './is-function.js';
import isNotEmpty from './is-not-empty.js';

export default function resolveFieldData (data, field) {
  if (!data ||  !field)
    return null;

  try {
    const value = data[field];
    if (isNotEmpty(value)) return value;
  }
  // eslint-disable-next-line no-empty
  catch {}

  if (Object.keys(data).length) {
    if (isFunction(field)) {
      return field(data);
    }
    else if (field.indexOf('.') === -1) {
      return data[field];
    }
    else {
      const fields = field.split('.');
      let value = data;
      for (let i = 0, len=fields.length; i < len; ++i) {
        if (value == null) return null;
        value = value[fields[i]];
      }
      return value;
    }
  }
  return null;
}
